export default __webpack_public_path__ + "static/media/vendit_logo_white.ba67bcc8.svg";